import { ColorTarget } from '@mode-vegas/vegas';
import { Injectable } from '@angular/core';
import { FlamingoFacade } from '@mode/switch-views/contract';
import { DataViewFacade } from '@mode/switch-views/contract';
import { AccountFacade } from '@mode/accounts/contract';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as ChartSwitchActions from '../chart/chart-switch.actions';

import { Store } from '@ngrx/store';
import { withLatestSnapshot } from '../helpers';
import { EncodingHelpers, createFieldColors } from '@mode/charts/util-vegas';
import { DomainAppState } from '../charts-domain.types';
import { map } from 'rxjs/operators';

@Injectable()
export class ColorEffects {
  constructor(
    private store: Store<DomainAppState>,
    private actions$: Actions,
    private flamingoFacade: FlamingoFacade,
    private accountFacade: AccountFacade,
    private dataViewFacade: DataViewFacade
  ) {}

  updateFieldColor$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ChartSwitchActions.updateDesignerFieldColor),
      withLatestSnapshot(this.store, 'token'),
      map(({ action, token, snapshot }) => {
        // If a color target is supplied, update the encoding as well
        const encoding =
          action.colorTarget !== undefined
            ? EncodingHelpers.updateMarkColorTarget(snapshot.encoding, action.colorTarget).encoding
            : snapshot.encoding;
        return ChartSwitchActions.updateChart({
          token,
          chart: {
            ...snapshot,
            encoding,
            fieldColors: createFieldColors(snapshot, action),
          },
          sourceAction: action.type,
        });
      })
    )
  );
}
